import { Button } from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  checkServiceAuth,
  getServiceAuthUrl,
  revokeService,
} from "../../../../APICalling/ServiceAPICalling";
// import { authCheckDuration } from "../../../../config/otherConstant";

import {
  authCheckDuration,
  getOpenSnakErrorData,
  getOpenSnakSuccessData,
  maxAuthCheck,
  snackDetails,
} from "../../../../config/otherConstant";
import RevokeDialog from "./RevokeDialog";
let checkAuthCount;

function OAuth2Authentication({
  apiKey,
  orgId,
  dataCenterUrl,
  dataCenter,
  zApiKey,
  serviceAuth,
  setServiceAuth,
  service,
  serviceConnection,
  currentUser,
  handlefetchConnections,
  settingId,
  setSnack,
  submitData,
}) {
  const [authLoading, setAuthLoading] = useState(true);
  const [revokeLoading, setRevokeLoading] = useState(false);

  let serviceHeaders = {
    orgid: orgId,
    apikey: apiKey,
    datacenterurl: dataCenterUrl,
    dataCenter: dataCenter,
    connname: serviceConnection,
    zapikey: zApiKey,
  };

  const handleAuthenticate = async () => {
    setAuthLoading(true);
    let body = {
      orgId: orgId,
      apiKey: apiKey,
      zapiKey: zApiKey,
    };

    serviceHeaders = {
      ...serviceHeaders,
      ...service,
      connName:
        service?.serviceConnection +
        "__" +
        submitData?.connApiName +
        "__" +
        currentUser?.email,
      scope: submitData?.scopes,
      settingId: settingId,
    };

    const serviceAuthUrl = await getServiceAuthUrl(body, serviceHeaders);
    if (!serviceAuthUrl) {
      // Set snak error
      setAuthLoading((prev) => false);
      setSnack(getOpenSnakErrorData());
      return "Error";
    }

    checkAuthCount = 1;
    const myAuthCheckInterval = setInterval(async () => {
      const authCheckStatus = await handleAuthCheck();

      console.log({ authCheckStatus });
      if (authCheckStatus) {
        setSnack(getOpenSnakSuccessData());
        handlefetchConnections();
        setServiceAuth((prev) => true);
        setAuthLoading((prev) => false);
        clearInterval(myAuthCheckInterval);
      }
      if (checkAuthCount++ > maxAuthCheck) {
        setSnack(
          getOpenSnakErrorData(
            "Error!!! Please authenticate and refresh the page.",
            10 * 1000
          )
        );
        setAuthLoading((prev) => false);
        clearInterval(myAuthCheckInterval);
        handlefetchConnections()
      }
    }, authCheckDuration);

    const newwindow = window.open(
      serviceAuthUrl,
      "windowName",
      "height=640,width=1024"
    );

    if (window.focus) {
      newwindow.focus();
    }
  };

  const handleAuthCheck = async () => {
    try {
      serviceHeaders = {
        ...serviceHeaders,
        ...service,
        connName:
          service?.serviceConnection +
          "__" +
          submitData?.connApiName +
          "__" +
          currentUser?.email,
        scope: submitData?.scopes,
      };
      const zohoAuthResp = await checkServiceAuth(serviceHeaders);
      return zohoAuthResp;
    } catch (error) {
      return false;
    }
  };

  const handleRevoke = async () => {
    serviceHeaders = {
      ...serviceHeaders,
      ...service,
      connName:
        service?.serviceConnection +
        "__" +
        submitData?.connApiName +
        "__" +
        currentUser?.email,
      scope: submitData?.scopes,
    };
    setRevokeLoading((prev) => true);
    const revokeResp = await revokeService(serviceHeaders);
    console.log({ revokeResp });
    const authCheckStatus = await checkServiceAuth(serviceHeaders);
    setServiceAuth((prev) => authCheckStatus);
    setSnack(getOpenSnakSuccessData());
    setRevokeLoading((prev) => false);
  };

  const checkAuth = async (cb) => {
    serviceHeaders = {
      ...serviceHeaders,
      ...service,
      connName:
        service?.serviceConnection +
        "__" +
        submitData?.connApiName +
        "__" +
        currentUser?.email,
      scope: submitData?.scopes,
    };
    const zohoStatus = await checkServiceAuth(serviceHeaders);
    console.log({ zohoStatus });
    cb(zohoStatus);
  };

  useEffect(() => {
    if (orgId && apiKey) {
      checkAuth((bool) => {
        setServiceAuth((prev) => bool);
        setAuthLoading((prev) => false);
      });
    }
  }, []);

  if (authLoading) {
    return (
      <Button disabled variant="outlined">
        Authenticating...
      </Button>
    );
  }

  if (revokeLoading) {
    return (
      <Button disabled variant="outlined">
        Revoking...
      </Button>
    );
  }

  if (!serviceAuth) {
    return (
      <Button onClick={handleAuthenticate} variant="outlined" fullWidth>
        Authenticate {service?.name}
      </Button>
    );
  }

  if (serviceAuth) {
    return (
      <RevokeDialog
        service={service?.name}
        handleRevokeService={handleRevoke}
      />
    );
  }

  return <></>;
}

export default OAuth2Authentication;
